import { render, staticRenderFns } from "./mianzheng.vue?vue&type=template&id=364a9c71&scoped=true&"
import script from "./mianzheng.vue?vue&type=script&lang=js&"
export * from "./mianzheng.vue?vue&type=script&lang=js&"
import style0 from "./mianzheng.vue?vue&type=style&index=0&id=364a9c71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364a9c71",
  null
  
)

export default component.exports